import { useState } from "react";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, http, errorText } from "@/lib/api";

const EMPTY = { name: "", email: "", phone: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!API) {
      toast.error("Booking is unavailable right now. Please email grow@scalesolutions.in.");
      return;
    }
    setStatus("loading");
    try {
      await http.post("/enquiries", form);
      setStatus("done");
      setForm(EMPTY);
      toast.success("Thank you — your request has been received. Sadiya will be in touch shortly.");
    } catch (err) {
      setStatus("idle");
      toast.error(errorText(err));
    }
  };

  if (status === "done") {
    return (
      <div className="border border-white/15 p-10 text-center" data-testid="contact-form-success">
        <span className="mx-auto flex h-12 w-12 items-center justify-center border border-[#B8874A]">
          <Check className="h-5 w-5 text-[#B8874A]" strokeWidth={1.5} />
        </span>
        <p className="font-display text-2xl mt-6">Request received.</p>
        <p className="mt-3 text-white/70 text-[15px]">Thank you for reaching out. You'll hear back within one to two working days.</p>
        <button onClick={() => setStatus("idle")} className="mt-8 link-underline text-[13px] text-white/80" data-testid="contact-form-reset-button">Send another message</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="text-left grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6" data-testid="contact-form">
      <input className="field" placeholder="Full name *" required minLength={2} value={form.name} onChange={set("name")} data-testid="contact-name-input" />
      <input className="field" type="email" placeholder="Email address *" required value={form.email} onChange={set("email")} data-testid="contact-email-input" />
      <input className="field sm:col-span-2" type="tel" placeholder="Phone" value={form.phone} onChange={set("phone")} data-testid="contact-phone-input" />
      <textarea className="field sm:col-span-2 resize-none" rows={4} placeholder="What would you like to discuss?" value={form.message} onChange={set("message")} data-testid="contact-message-input" />
      <div className="sm:col-span-2 flex justify-center pt-4">
        <button
          type="submit"
          disabled={status === "loading"}
          className="btn-brass on-dark group inline-flex items-center gap-3 px-9 py-4 text-sm font-medium tracking-wide disabled:opacity-70"
          data-testid="contact-submit-button"
        >
          {status === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Book a Discovery Session
          <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} />
        </button>
      </div>
    </form>
  );
};
